import { initFlowbite, Modal } from 'flowbite';
import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/css';
import { Thumbs } from 'swiper/modules';

$(() => {
  $(document).on('click', '.favourite-btn', function (event) {
    event.preventDefault();
    event.stopPropagation();
  });

  $(document).on('click', '.quick-view-button', function (event) {
    event.preventDefault();
    event.stopPropagation();
    const quickViewButton = $(this);
    const modalId = 'quick-view-modal-' + $(this).data('product-id');

    if (!$('body > #quick-view-modal-' + $(this).data('product-id')).length) {
      const spinnerLoader = `
      <div class="quick-view-loading bg-gray-900/50 fixed inset-0 z-40 flex items-center justify-center">
        <div role="status">
            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    `;

      $.ajax({
        type: 'GET',
        url: ajax_object.ajax_url,
        data: {
          action: 'get_product_card_quick_view_data',
          productID: quickViewButton.data('product-id'),
        },
        dataType: 'json',
        beforeSend: () => {
          $('body').append(spinnerLoader);
        },
        success: (response) => {
          if (response.success) {
            $('body').append(response.data.product_quick_view_html);
            initFlowbite();
            const $targetEl = $('#' + modalId)[0];
            const options = {
              placement: 'bottom-right',
              backdrop: 'dynamic',
              backdropClasses: 'bg-gray-900/50 fixed inset-0 z-40',
              closable: true,
              onHide: () => {},
              onShow: () => {
                $('body').removeClass('overflow-hidden');
                const swiperThumbs = new Swiper(
                  '#' + modalId + ' .swiper-thumbs',
                  {
                    loop:
                      $('#' + modalId + ' .swiper-thumbs .swiper-slide')
                        .length >= 5,
                    spaceBetween: 7,
                    slidesPerView: 5,
                    slideToClickedSlide: true,
                  }
                );

                const swiperMain = new Swiper('#' + modalId + ' .swiper-main', {
                  loop: true,
                  modules: [Thumbs],
                  thumbs: {
                    swiper: swiperThumbs,
                  },
                });

                $('#' + modalId + ' .main-prev').on('click', function () {
                  swiperMain.slidePrev();
                  swiperThumbs.slidePrev();
                });
                $('#' + modalId + ' .main-next').on('click', function () {
                  swiperMain.slideNext();
                  swiperThumbs.slideNext();
                });
                $('#' + modalId + ' .thumbs-prev').on('click', function () {
                  $('.tooltip-clone').remove();
                  swiperThumbs.slidePrev();
                  swiperMain.slidePrev();
                });
                $('#' + modalId + ' .thumbs-next').on('click', function () {
                  $('.tooltip-clone').remove();
                  swiperThumbs.slideNext();
                  swiperMain.slideNext();
                });

                $(document).on(
                  'mouseenter',
                  '#' + modalId + ' .swiper-thumbs .swiper-slide',
                  function () {
                    const $hoveredSlide = $(this);
                    const $img = $hoveredSlide.find('img');
                    const altText = $img.attr('alt');

                    if (!altText) return;

                    $('.image-tooltip').remove();

                    const $tooltip = $('<div>')
                      .addClass(
                        'image-tooltip invisible opacity-0 whitespace-nowrap fixed h-fit px-1.5 py-1 text-[10px] text-white font-semibold transition-opacity duration-300 bg-[#111013] rounded-[3px]'
                      )
                      .text(altText)
                      .css({
                        zIndex: 9999,
                      });
                    $('body').append($tooltip);

                    const rect = $img[0].getBoundingClientRect();
                    const tooltipRect = $tooltip[0].getBoundingClientRect();
                    const left =
                      rect.left + (rect.width - tooltipRect.width) / 2;
                    const top = rect.top - tooltipRect.height - 4;
                    $tooltip.css({
                      left: `${left}px`,
                      top: `${top}px`,
                      visibility: 'visible',
                      opacity: 1,
                    });
                  }
                );

                $(document).on(
                  'mouseleave',
                  '#' + modalId + ' .swiper-thumbs .swiper-slide',
                  function () {
                    $('.image-tooltip').remove();
                  }
                );
              },
              onToggle: () => {},
            };
            const instanceOptions = {
              id: modalId,
              override: true,
            };
            const modal = new Modal($targetEl, options, instanceOptions);

            modal.show();
          } else {
            console.log(response.data);
          }
        },
        error: (error) => {
          console.error(
            'AJAX Error Loading Product Tab Contents: ',
            error.responseText
          );
        },
        complete: () => {
          $('.quick-view-loading').remove();
        },
      });
    } else {
      const modal = new Modal($('#' + modalId)[0]);
      modal.show();
      $('body').removeClass('overflow-hidden');
    }
  });
});
